import { CurrentEnvironment } from 'root-constants'

export function getCurrentEnv(): CurrentEnvironment {
  return (document.querySelector('meta[name="current-env"]') as HTMLMetaElement)
    .content as CurrentEnvironment
}
